export default __webpack_public_path__ + "static/media/Chestplate of Courageous Souls.b2730fe5.jpg";